import _ from "lodash";
import dayjs from "dayjs";
import { connect } from "react-redux";
import { StyledBox, StyledBoxHeader } from "../../../CSS/style";
import { PlusOutlined } from "@ant-design/icons";
import { check } from "../../../Utils/FormCalls";
import { decode as base64_decode } from "base-64";
import FileBase64 from "../../../Utils/FileUpload";
import { constant } from "../../../Utils/constants";
import { PaperClipOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
// import translation from "../../../../../commons/translation";
import localStorage from "../../../../../utils/localStorage";
import InputComponent from "../../../Widgets/InputComponent";
import { API_MASTERLABOUR } from "../../../../../commons/api";

import { Form, message, Select, Divider, Space, Modal,Button } from "antd";
import InputNumberComponent from "../../../Widgets/InputNumberComponent";
import {
  getSitesList,
  submitMaster,
  getMasterById,
  getSkillTypeList,
  insertSkillType,
} from "../../../Utils/FormCalls";
import { StyledHomepageSides } from "../../../../../commons/styles/layout";

const { Option } = Select;
const urlList = {
  insert: API_MASTERLABOUR.INSERT,
  getbyId: API_MASTERLABOUR.GetById,
};
const type = "Labor";
const fileData = new FormData();

const ManPowerDetails = (props) => {
  const [sitesList, setSitesList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [SkilTypeList, setSkilTypeList] = useState([]);
  const [viewSkillType, setViewSkillType] = useState(false);
  const [Attachments, setAttachments] = useState(props.Attachments || {});

  const hRef = useRef();
  const SkillRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      try {
        let sitesList = await getSitesList();
        let formObject = hRef.current.getFieldsValue();
        formObject = {
          ...formObject,
          SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
        };
        hRef.current.setFieldsValue(formObject);
        setSitesList(sitesList);
        setFormObject(formObject);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let SkilTypeList = await getSkillTypeList();
        setSkilTypeList(SkilTypeList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (hRef.current) hRef.current.setFieldsValue(props.formObject);
    }
    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
      setAttachments(props.Attachments);
    }
  }, [props]);

  const _getDataById = async () => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/ManPowerDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new') {
      let data = await getMasterById(urlList.getbyId, base64_decode(path[1]), 'GET');
      formObject = data && data !== undefined ? data : {};
      _.cloneDeepWith(data, (value) => {
        return value && value !== null && value.StartTime && value.EndTime
          ? {
            ...value,
            ...(value['StartTime'] = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')),
            ...(value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
          }
          : _.noop();
      });
    }
    if (hRef.current) {
      hRef.current.setFieldsValue(formObject);
    }
    setFormObject(formObject);
  };

  const fileupload = async (values, key, fileDataObject) => {
    let formObject = hRef.current.getFieldsValue();

    if (formObject[key]) {
      formObject[key].push(...values);
    } else {
      formObject[key] = values;
    }
    formObject[key] =
      formObject[key] &&
      formObject[key].reduce((acc, current) => {
        const x = acc.find((item) => item.Name === current.Name);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    formObject = {
      ...formObject,
      [key]: formObject[key]
    };
    fileData.append('files', fileDataObject);
    if (hRef.current) hRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const onFormsubmit = async (values) => {
    let userId =
      props.userProfile && props.userProfile.user && props.userProfile.user.Id
        ? props.userProfile.user.Id
        : '';
    let payload = {
      ...formObject,
      ...values,
      ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
      ...(formObject && formObject.Id ? { UpdatedBy: userId } : {}),
      Id: formObject.Id
    };
    let statusResponse = await submitMaster(urlList.insert, payload, fileData, type);
    if (statusResponse && statusResponse.message) {
      _getDataById(statusResponse.Id);
      message.success(statusResponse.message);
      props.navigate('/rubus/AMM/ManPowerList');
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onChange = () => {
    let formObject = hRef.current.getFieldsValue();
    setFormObject({
      ...formObject
    });
    hRef.current.setFieldsValue(formObject);
  };

  const onModalSkillTypeFormsubmit = (e) => {
    e.preventDefault();
    SkillRef.current
      .validateFields()
      .then(async (values) => {
        let payload = {
          ...values
        };
        let SkillTypeResponse = await insertSkillType(payload);
        if (SkillTypeResponse) {
          message.success(SkillTypeResponse.message);
          let SkilTypeList = await getSkillTypeList();
          let formObject = SkillRef.current.getFieldsValue();
          SkillRef.current.setFieldsValue(formObject);
          setViewSkillType(false);
          setSkilTypeList(SkilTypeList);
          if (SkillRef.current) {
            SkillRef.current.resetFields();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const oncloseSkill = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      if (SkillRef.current) {
        SkillRef.current.resetFields();
      }
      setViewSkillType(false);
    }
  };

  const onReset = () => {
    if (hRef.current) hRef.current.resetFields();
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  // const getValueFromList = (list, compareKey, compareValue, resultKey) => {
  //   let filterObject = [];
  //   if (list && Array.isArray(list)) {
  //     filterObject = list.filter((listObject) => listObject[compareKey] === compareValue);
  //   }
  //   return filterObject && filterObject[0] && filterObject[0][resultKey]
  //     ? filterObject[0][resultKey]
  //     : '';
  // };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    }
  };
//  const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;
 
  return (
    <StyledHomepageSides>
      <Form
        name="Item"
        ref={hRef}
        initialValues={formObject}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        layout="vertical"
        validateMessages={validateMessages}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {translation(constant.submit)}
            </Button>
          </Form.Item>
        </div>

        <StyledBoxHeader>
          <StyledBox >
            <Form.Item
              
              label={translation(constant.personTitle)}
              name="Title"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.inputPersonTitle)}
                
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.personFirstName)}
              name="FirstName"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation("inputPersonFirstName")}
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.personLastName)}
              name="LastName"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation("inputPersonLastName")}
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.site)}
              name="SiteId"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '100%' }}
                placeholder={translation("selectSite")}
                disabled={formObject && formObject.Id ? true : false}
              >
                {sitesList.map((site, index) => (
                  <Option key={index} value={site.Id}>
                    {site.Name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          
            <Form.Item
              
              label={translation(constant.email)}
              name="Email"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.SendEmail)}
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.language)}
              name="Language"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.inputLanguage)}
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.countryCode)}
              name="CountryCode"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.inputcountryCode)}
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.phoneNumber)}
              name="PhoneNumber"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation("inputPhoneNumber")}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
          
            <Form.Item
              
              label={translation(constant.address)}
              name="Address"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation("inputAddress")}
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.city)}
              name="City"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.inputCity)}
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.state)}
              name="State"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.inputstate)}
              />
            </ Form.Item>
            <Form.Item
              
              label={translation(constant.country)}
              name="Country"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.inputCountry)}
              />
            </Form.Item>

          
            <Form.Item
              
              label={translation(constant.zipCode)}
              name="ZipCode"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.inputZipCode)}
              />
            </Form.Item>
            <Form.Item
              
              name="Attachments"
              label={
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    {translation(constant.attachments)}
                    <PaperClipOutlined className="plusCircleOutlined" />
                  </span>
                </div>
              }
            >
              <FileBase64
                style={{ width: '100%' }}
                downloadClassName={'formdownloadInput'}
                Attachments={Attachments}
                fileUpload={fileupload}
              />
            </Form.Item>
            <Form.Item
              
              label={translation(constant.Skill)}
              name="SkillTypeId"
            >
              <Select
                style={{ width: '100%' }}
                placeholder={translation(constant.addSkill)}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: '8px 0' }} />
                    <Space style={{ padding: '0 8px 4px' }}>
                      <Button
                        type="dashed"
                        icon={<PlusOutlined />}
                        onClick={() => setViewSkillType(true)}
                      >
                        {translation("addSkillType")}
                      </Button>
                    </Space>
                  </>
                )}
              >
                {SkilTypeList.map((skill, index) => (
                  <Option key={index} value={skill.Id}>
                    {skill.Type}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              
              label={translation(constant.Quantity)}
              name="AvailableQuantity"
              rules={[
                { required: true },
                {
                  validator: (_, value) => check(value, 'Item', { validateDecimal: true })
                }
              ]}
            >
              <InputNumberComponent
                style={{ width: '100%' }}
                placeholder={translation(constant.inputQuantity)}
              />
            </Form.Item>
           
            <Form.Item name="Id"></Form.Item>
          </StyledBox>
          <Modal
            title={translation(constant.addSkill)}
            open={viewSkillType}
            okText={'Submit'}
            onOk={onModalSkillTypeFormsubmit}
            onCancel={oncloseSkill}
          >
            <Form
              layout="vertical"
              ref={SkillRef}
              name="user_form"
              onFinish={onModalSkillTypeFormsubmit}
            >
              <Form.Item
                label={translation(constant.type)}
                name={'Type'}
                rules={[{ required: true }]}
              >
                <InputComponent
                  placeholder={translation(constant.inputType)}
                  onChange={onChange}
                />
              </Form.Item>
              <Form.Item
                label={translation(constant.description)}
                name={'Description'}
                rules={[{ required: true }]}
              >
                <InputComponent
                  placeholder={translation(constant.inputDescription)}
                />
              </Form.Item>
            </Form>
          </Modal>
        </StyledBoxHeader>
      </Form>
    </StyledHomepageSides>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.userProfile,
  };
};

export default connect(mapStateToProps)(ManPowerDetails);